import { forwardRef } from 'react';
import './DesktopVideoMockup.css';

interface DesktopVideoMockupProps {
  videoSrc: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
}

interface DesktopVideoMockupProps {
  videoSrc: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  screenAreaRef?: React.RefObject<HTMLDivElement | null>; // Add ref for screen area
}

const DesktopVideoMockup = forwardRef<HTMLVideoElement, DesktopVideoMockupProps>(
  (
    { videoSrc, autoplay = false, loop = true, muted = true, controls = false, screenAreaRef },
    ref
  ) => {
    return (
      <div className="desktop-mockup-container">
        <div className="desktop-screen-area" ref={screenAreaRef}>
          <video
            id="desktop-video"
            ref={ref}
            src={videoSrc}
            autoPlay={autoplay}
            loop={loop}
            muted={muted}
            playsInline
            controls={controls}
            className="desktop-screen-video"
          />
        </div>
        <img src="/desktop-frame.png" alt="Desktop frame" className="desktop-frame" />
      </div>
    );
  }
);

DesktopVideoMockup.displayName = 'DesktopVideoMockup';

export default DesktopVideoMockup;
